import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Error404Component } from './pages/error/error404/error404.component';
import { Error403Component } from './pages/error/error403/error403.component';

import { TermoAceiteComponent } from './pages/termo-aceite/termo-aceite.component';
import { CanditadoListarComponent } from './pages/eleitor/canditado-listar/canditado-listar.component';
import { ComprovanteVotoComponent } from './pages/eleitor/comprovante-voto/comprovante-voto.component';
import { InitialComponent } from './pages/initial/initial.component';
import { RedirectNavegadorIeComponent } from './pages/redirect-navegador-ie/redirect-navegador-ie.component';
import { ListaGestoresComponent } from './pages/admin/lista-gestores/lista-gestores.component';
import { CadastroGestorComponent } from './pages/admin/cadastro-gestor/cadastro-gestor.component';
import { CadastroAssistenteComponent } from './pages/admin/cadastro-assistente/cadastro-assistente.component';
import { GestorComponent } from './pages/gestor/gestor.component';
import { ResultadoEleicaoComponent } from './pages/gestor/resultado-eleicao/resultado-eleicao.component';
import { RelatorioVotosComponent } from './pages/gestor/relatorio-votos/relatorio-votos.component';
import { RelatorioEmailComponent } from './pages/gestor/relatorio-email/relatorio-email.component';
import { RelatorioEmailDetalhadoComponent } from './pages/gestor/relatorio-email-detalhado/relatorio-email-detalhado.component';
import { CadastroEleicaoComponent } from './pages/gestor/cadastro-eleicao/cadastro-eleicao.component';
import { CountdownComponent } from './pages/countdown/countdown.component';
import { ParametrizacoesComponent } from './pages/gestor/parametrizacoes/parametrizacoes.component';
import { ParametrizacoesEmailComponent } from './pages/gestor/parametrizacoes-email/parametrizacoesEmail.component';
import { ListaEleicoes } from './pages/gestor/preview/lista-eleicoes/lista-eleicoes.component';
import { GerarNovaSenhaComponent } from './pages/login/gerar-nova-senha/gerar-nova-senha.component';
import { PreVisualizarEleicaoComponent } from './pages/gestor/pre-visualizar-eleicao/pre-visualizar-eleicao.component';
import { ResultadoParcialEleicaoComponent } from './pages/gestor/resultado-parcial-eleicao/resultado-parcial-eleicao.component';
import { GerarNovaSenhaAprovadorComponent } from './pages/login/gerar-nova-senha-aprovador/gerar-nova-senha-aprovador.component';
import { FormularioPreCandidatoComponent } from './pages/precandidato/formulario-precandidato.component';
import { RedirecionamentoIntegracao } from './pages/redirecionamento-integracao/redirecionamento-integracao.component';
import { ConfirmaComponent } from './pages/precandidato/confirma/confirma.component';
import { AcessoNegadoComponent } from './pages/acesso-negado/acesso-negado.component';
import { LoginComponent } from './pages/login/login.component';
import { CargoComponent } from './pages/gestor/parametrizacoes/cargo/cargo.component';
import { ListaCargosAprovadorComponent } from './pages/aprovador/lista-cargos.component';
import { ListaCandidaturasComponent } from './pages/aprovador/Candidaturas/lista-candidaturas.component';
import { PreCandidaturaRealizadaComponent } from './pages/precandidato/pre-candidatura-realizada/pre-candidatura-realizada.component';
import { ParametrizacoesAssistenteComponent } from './pages/assistente/parametrizacoes/parametrizacoes-assistente.component';

const routes: Routes = [
  {
    path: 'admin',
    children: [
      {
        path: '', component: InitialComponent
      },
      {
        path: 'lista-gestores', component: ListaGestoresComponent
      },
      {
        path: 'lista-gestores/cadastro-gestor', component: CadastroGestorComponent
      },
      {
        path: 'lista-gestores/cadastro-assistente', component: CadastroAssistenteComponent
      },
    ]
  },
  {
    path: 'gestor',
    children: [
      {
        path: '', component: InitialComponent
      },
      {
        path: 'lista-eleicoes', component: GestorComponent
      },
      {
        path: 'lista-eleicoes/cadastro-eleicao', component: CadastroEleicaoComponent
      },
      {
        path: 'lista-eleicoes/resultado-eleicao', component: ResultadoEleicaoComponent
      },
      {
        path: 'lista-eleicoes/resultado-parcial-eleicao', component: ResultadoParcialEleicaoComponent
      },
      {
        path: 'lista-eleicoes/countdown', component: CountdownComponent
      },
      {
        path: 'configuracoes', component: ParametrizacoesComponent
      },
      {
        path: 'config-email', component: ParametrizacoesEmailComponent
      },
      {
        path: 'preview', component: PreVisualizarEleicaoComponent
      },
      {
        path: 'relatorio-votos', component: RelatorioVotosComponent
      },
      {
        path: 'relatorio-email', component: RelatorioEmailComponent
      },
      {
        path: 'relatorio-email-detalhado', component: RelatorioEmailDetalhadoComponent
      },
    ]
  },
  {
    path: 'assistente',
    children: [
      {
        path: '', component: InitialComponent
      },
      {
        path: 'eleicoes', component: GestorComponent
      },
      {
        path: 'preview', component: PreVisualizarEleicaoComponent
      },
      {
        path: 'configuracoes', component: ParametrizacoesAssistenteComponent
      },
      {
        path: 'config-email', component: ParametrizacoesEmailComponent
      },
      {
        path: 'eleicoes/resultado-eleicao', component: ResultadoEleicaoComponent
      },
      {
        path: 'eleicoes/resultado-parcial-eleicao', component: ResultadoParcialEleicaoComponent
      },
      {
        path: 'relatorio-votos', component: RelatorioVotosComponent
      },
      {
        path: 'relatorio-email', component: RelatorioEmailComponent
      },
    ]
  },
  {
    path: 'acesso-negado', component: AcessoNegadoComponent
  },
  {
    path: ':rotaEleicao',
    children: [
      {
        path: '', component: InitialComponent
      },
      {
        path: 'eleitor/termo', component: TermoAceiteComponent
      },
      {
        path: 'eleitor/candidatos', component: CanditadoListarComponent
      },
      {
        path: 'eleitor/comprovante', component: ComprovanteVotoComponent
      },
      {
        path: 'gerar-nova-senha/:token', component: GerarNovaSenhaComponent
      },
      {
        path: 'gerar-nova-senha-aprovador/:token', component: GerarNovaSenhaAprovadorComponent
      },
      {
        path: 'confirma', component: ConfirmaComponent
      },
      {
        path: 'precandidato', component: FormularioPreCandidatoComponent
      },
      {
        path: 'precandidato/realizada', component: PreCandidaturaRealizadaComponent
      },
      {
        path: 'aprovador', component: LoginComponent
      },
      {
        path: 'aprovador/lista-cargos', component: ListaCargosAprovadorComponent
      },
      {
        path: 'aprovador/candidaturas', component: ListaCandidaturasComponent
      }
    ]
  },
  {
    path: 'integracao/:token', component: RedirecionamentoIntegracao
  },
  {
    path: 'error-sessao', component: Error403Component,
  },
  { path: 'navegadores', component: RedirectNavegadorIeComponent },
  {
    path: '**', component: Error404Component,
    // canActivate: [AuthGuardService,]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


